import React from 'react'
import Page from '../../../../ui/Page'
import { Button, Table } from 'antd'
import useDiplomaApprove from './useDiplomaApprove';
import { GraduationThesisDto } from '../../../../interfaces/Student/StudentGraduationThesisChooseDto';
import { useHistory, useParams } from 'react-router-dom';
import { LeftOutlined } from '@ant-design/icons';

const OfficeDiplomaApprove = () => {
    const history = useHistory();
    const { settingId } = useParams<{ settingId: string }>();
    const { groupedByTeacher, isGraduationThesisLoading, expandedRowRender, columns, contextHolder } = useDiplomaApprove(settingId);

    return (
        <Page>
            <Button onClick={() => history.goBack()} style={{ marginBottom: 20 }}>
                <LeftOutlined /> Back
            </Button>
            <Table
                bordered
                dataSource={groupedByTeacher}
                columns={columns}
                loading={isGraduationThesisLoading}
                rowKey={(record) => record.teacher}
                expandable={{
                    expandedRowRender: record => expandedRowRender(record.thesisList.sort((a: GraduationThesisDto, b: GraduationThesisDto) => a.id - b.id)),
                    rowExpandable: record => record.thesisList.length > 0,
                }}
                scroll={{ x: 800 }}
                pagination={{
                    pageSize: 20,
                }}
            />
            {contextHolder}
        </Page>
    )
}

export default OfficeDiplomaApprove